import { render, staticRenderFns } from "./GraficoEvolucaoIndiceVegetacao.vue?vue&type=template&id=af2a082e&scoped=true&lang=pug"
import script from "./GraficoEvolucaoIndiceVegetacao.vue?vue&type=script&lang=js"
export * from "./GraficoEvolucaoIndiceVegetacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2a082e",
  null
  
)

export default component.exports